import { render } from "./NotificationView.vue?vue&type=template&id=5aca4d6e&scoped=true"
import script from "./NotificationView.vue?vue&type=script&lang=js"
export * from "./NotificationView.vue?vue&type=script&lang=js"

import "./NotificationView.vue?vue&type=style&index=0&id=5aca4d6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aca4d6e"]])

export default __exports__